import React, {Component} from 'react';
import { connect } from 'react-redux';
// import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Form from './Form';
import { create, loading, error } from '../../actions/client/create';
import { list as languageList } from '../../actions/language/list';
import { list as productList } from '../../actions/product/list';
import { literals } from './../../languages';
import { getUserRoles } from '../../utils/helpers';


class Create extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    created: PropTypes.object,
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.getLanguages();
    this.props.getProducts();
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentWillReceiveProps(nextProps){
    if (this.props.created !== nextProps.created){
      this.props.submitCallback();
    }
  }

  render() {
    // if (this.props.created) return <Redirect to={`edit/${encodeURIComponent(this.props.created['@id'])}`}/>;

    return <div>
      {this.props.loading && <div className="alert alert-info" role="status">{literals.loadingMessage[this.props.locale]}</div>}
      {this.props.error && <div className="alert alert-danger" role="alert"><span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {this.props.error}</div>}

      <Form locale={this.props.locale} ref="form" onSubmit={(values)=>{this.props.create(values); }} values={this.props.item} languages={this.props.languages} products = {this.props.products} initialValues={this.props.initialValues} />
    </div>;
  }
}

const mapStateToProps = (state) => {
  let clientProducts = state.product.list.data['hydra:member'];

   //DEDOULIS HIDE TZIROI APP AND WIDGET FROM PUBLIC
   let token = localStorage.getItem('betwidgets_login_token');
   let isAdmin = false;
   if (token) {
     let roles = getUserRoles(token);
       isAdmin =  roles.indexOf('ROLE_ADMIN') !== -1  ? true : false;
   }

   if (!isAdmin) {
     clientProducts = clientProducts && clientProducts.slice().filter( p => {
       return ['/api/products/1', '/api/products/2'].indexOf(p['@id']) === -1;
     });
   }

  return {
    created: state.client.create.created,
    error: state.client.create.error,
    loading: state.client.create.loading,
    languages: state.language.list.data['hydra:member'],
    products: state.product.list.data['hydra:member'],
    initialValues: {
      'clientProducts': clientProducts
    }
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    create: values => dispatch(create(values)),
    reset: () => {
      dispatch(loading(false));
      dispatch(error(null));
    },
    getLanguages: values => dispatch(languageList()),
    getProducts: values => dispatch(productList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Create);



// WEBPACK FOOTER //
// ./src/components/client/Create.js